export const mediaSortType = Object.freeze({
  UPLOADED_AT: 'uploadedAt',
});
